const monthOption = [];
const yearOption = [];
export const hostedFieldsOption = {
    styles: {
        'input.number': {
            'font-size': '14px',
            'padding-top': '15px'
        },
        'input.cvv': {
            'font-size': '14px',
            'padding-top': '15px'
        }
    },
    fields: {
        number: {
            container: '#cc-number',
            placeholder: ''
        },
        expirationMonth: {
            container: '#cc-expiration-month',
            select: monthOption,
            placeholder: 'Month'
        },
        expirationYear: {
            container: '#cc-expiration-year',
            select: yearOption,
            placeholder: 'Year'
        },
        cvv: {
            container: '#cc-cvv',
            placeholder: ''
        },
    }
}
const cssConfig = {
    "font": "400 1rem/1.4 Telstra Akkurat,Helvetica Neue,Helvetica,Arial,sans-serif",
    "letter-spacing": "0.009375rem",
    "padding": "0 0.75rem",
    "-webkit-appearance": "none",
    "-moz-appearance": "none",
    "appearance": "none",
    "transition": "background-color 250ms linear,box-shadow 250ms linear",
};
export const styleConfig = {
    input: cssConfig,
    select: cssConfig,
};
export const hostedFieldsOptionAble = {
    styles: styleConfig,
    fields: {
        number: {
            container: '#cc-number',
            placeholder: '',
            internalLabel: 'Credit or debit card number. We accept Mastercard, Visa and American Express.',
        },
        expirationMonth: {
            container: '#cc-expiration-month',
            placeholder: '',
            internalLabel: 'Expiry date month. Enter the date as mm/yy.'
        },
        expirationYear: {
            container: '#cc-expiration-year',
            placeholder: '',
            internalLabel: 'Expiry date year. Enter the date as mm/yy.'
        },
        cvv: {
            container: '#cc-cvv',
            placeholder: '',
            internalLabel: 'Security code. This is a 3 or 4-digit number on your card.'
        },
    }
}

export const creditCardLabels = [{
    label: 'Card number',
    id: 'cc-number'
},
{
    label: 'Expiry date',
    fields: [
        {
            id: 'cc-expiration-month'
        },
        {
            id: 'cc-expiration-year'
        }]
},
{
    label: 'Security code (CVV)',
    id: 'cc-cvv'
}];

export const creditCardLabelsAble = [{
    label: 'Credit or debit card number',
    subLabel: 'We accept Mastercard, Visa and American Express.',
    id: 'cc-number',
},
{
    label: 'Expiry date',
    subLabel: 'Enter the date as mm/yy.',
    fields: [
        {
            id: 'cc-expiration-month'
        },
        {
            id: 'cc-expiration-year'
        }]
},
{
    label: 'Security code',
    subLabel: 'This is a 3 or 4-digit number on your card.',
    id: 'cc-cvv'
}];

export const BankLabels = [{
    label: 'Account name',
    id: 'accountName',
    autofocus: true
},
{
    label: 'BSB',
    id: 'bsb',
    autofocus: false
},
{
    label: 'Account number',
    id: 'accountNumber',
    autofocus: false
}
];

export const hostedFieldsOption2 = {
    styles: {
        'input': {
            'font-size': '14px'
        },
        'input.invalid': {
            color: 'red'
        },
        'input.valid': {
            color: 'green'
        }
    },
    fields: {
    }
}
export const hostedFieldsClassStruture = {
    number : {
        selector: '#cc-number',
        focusClass: 'tc-hosted-field-focus',
        class: 'tc-hosted-field'
    },
    cvv : {
        selector: '#cc-cvv',
        focusClass: 'tc-hosted-field-cvv-focus',
        class: 'tc-hosted-field-cvv'
    },
    expirationMonth : {
        selector: '#cc-expiration-month',
        focusClass: 'tc-hosted-month-field-focus',
        class: 'tc-hosted-month-field'
    },
    expirationYear : {
        selector: '#cc-expiration-year',
        focusClass: 'tc-hosted-year-field-focus',
        class: 'tc-hosted-year-field'
    },
}

export const hostedFieldsRequiredAndInvalid = {
    number : {
        required: 'invalid-field-cc-number',
        invalid: 'invalid-entry-field-cc-number',
        requiredMsg: 'Required field.',
        invalidMsg: 'Invalid entry. The number entered is not recognised.',
    },
    cvv : {
        required: 'invalid-field-cc-cvv',
        invalid: 'invalid-entry-field-cc-cvv',
        requiredMsg: 'Required field.',
        invalidMsg: 'Invalid length. Security code must be 3 or 4 digits.'
    },
    expirationMonth : {
        required: 'invalid-field-month-year',
        invalid: 'invalid-entry-field-month-year',
        requiredMsg: 'Required field.',
        invalidMsg: 'Invalid entry. Expiry date must be valid.'
    },
    expirationYear : {
        required: 'invalid-field-month-year',
        invalid: 'invalid-entry-field-month-year',
        requiredMsg: 'Required field.',
        invalidMsg: 'Invalid entry. Expiry date must be valid.'
    },
}
